import { render, staticRenderFns } from "./ProjectsCarroussel.vue?vue&type=template&id=2a1fb857&scoped=true&"
import script from "./ProjectsCarroussel.vue?vue&type=script&lang=js&"
export * from "./ProjectsCarroussel.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsCarroussel.vue?vue&type=style&index=0&id=2a1fb857&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1fb857",
  null
  
)

export default component.exports